"use client"

import { Badge } from "@/components/ui/badge"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { cn } from "@/lib/utils"

const MAX_VISIBLE = 2

function ThemeBadge({ theme }: { theme: string }) {
  return (
    <Badge variant="outline" className="border-violet-500/40 bg-violet-500/10 text-violet-300">
      {theme}
    </Badge>
  )
}

// 종목목록/관심종목/포트폴리오 공통 테마 표시: 2개까지 배지로 노출, 나머지는 "+N" 클릭 시 팝오버로 전체 목록 표시.
export function ThemeBadges({ themes, className }: { themes: string[]; className?: string }) {
  if (themes.length === 0) return <span className="text-zinc-600">-</span>

  const visible = themes.slice(0, MAX_VISIBLE)
  const rest = themes.slice(MAX_VISIBLE)

  return (
    <div className={cn("flex flex-wrap items-center gap-1", className)}>
      {visible.map((theme) => (
        <ThemeBadge key={theme} theme={theme} />
      ))}
      {rest.length > 0 && (
        <Popover>
          <PopoverTrigger asChild>
            <button
              type="button"
              className="rounded border border-zinc-600/50 bg-zinc-700/30 px-1.5 py-0.5 text-xs text-zinc-400 hover:bg-zinc-700/60"
            >
              +{rest.length}
            </button>
          </PopoverTrigger>
          <PopoverContent className="w-64 border-zinc-700 bg-zinc-900">
            <div className="flex flex-wrap gap-1">
              {themes.map((theme) => (
                <ThemeBadge key={theme} theme={theme} />
              ))}
            </div>
          </PopoverContent>
        </Popover>
      )}
    </div>
  )
}
